/**
 * 阅读进度统一保留 4 位小数，确保前端本地缓存、接口写入和定位精度一致。
 */
export const READING_PROGRESS_STORAGE_DECIMALS = 4

/**
 * 前端对用户展示阅读进度时统一保留 1 位小数。
 */
export const READING_PROGRESS_DISPLAY_DECIMALS = 1

/**
 * 统一用于判断阅读进度是否发生了可感知变化，避免重复写入。
 */
export const READING_PROGRESS_EPSILON = 0.0001

/**
 * 归一化阅读进度百分比到 0-100，并按指定精度四舍五入。
 */
export const normalizeReadingProgress = (value: unknown, decimals = READING_PROGRESS_STORAGE_DECIMALS): number => {
  const num = Number(value || 0)
  if (!Number.isFinite(num)) return 0
  const clamped = Math.max(0, Math.min(100, num))
  return Number(clamped.toFixed(decimals))
}

/**
 * 判断两个进度值是否可视为相同，避免前后端互相覆盖。
 */
export const isSameReadingProgress = (left: unknown, right: unknown, epsilon = READING_PROGRESS_EPSILON): boolean => {
  return Math.abs(normalizeReadingProgress(left) - normalizeReadingProgress(right)) <= epsilon
}

/**
 * 将阅读进度格式化为统一的前端展示文本。
 */
export const formatReadingProgress = (value: unknown, decimals = READING_PROGRESS_DISPLAY_DECIMALS): string => {
  return normalizeReadingProgress(value).toFixed(decimals)
}
